var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _path15, _path16, _polygon, _polygon2, _polygon3, _rect2, _path17, _path18, _path19, _path20, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ec6d3d;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #a61e1b;\n      }\n\n      .cls-4 {\n        fill: #c4e3f0;\n      }\n\n      .cls-5 {\n        fill: #e23223;\n      }\n\n      .cls-6 {\n        fill: #086c80;\n      }\n\n      .cls-7 {\n        fill: #0d4854;\n      }\n\n      .cls-8 {\n        fill: #70c4e4;\n      }\n\n      .cls-9 {\n        fill: #24b3cf;\n      }\n\n      .cls-10 {\n        fill: #511414;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M128,38c-49.71,0-90,40.29-90,90,0,38.47,24.14,71.31,58.1,84.18l117.05-113.39c-12.13-35.37-45.67-60.79-85.15-60.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M218,128c0-10.22-1.71-20.05-4.85-29.21l-39.76-39.76-41.88,27.63-19.43-19.43-39.37,121.55,23.4,23.4c9.91,3.76,20.66,5.82,31.89,5.82,49.71,0,90-40.29,90-90Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M86.52,61.48h5.87l17.61,66.52-17.61,66.52h-5.87c-10.76,0-19.57-8.8-19.57-19.57V81.04c0-10.76,8.8-19.57,19.57-19.57Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M98.26,61.48h-5.87V194.52h5.87c10.76,0,19.57-8.8,19.57-19.57V81.04c0-10.76-8.8-19.57-19.57-19.57Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.7,104.52c0,4.32,3.5,7.83,7.83,7.83h5.87l3.91-7.83-3.91-7.83h-5.87c-4.32,0-7.83,3.5-7.83,7.83Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.26,96.7h-5.87v15.65h5.87c4.32,0,7.83-3.5,7.83-7.83s-3.5-7.83-7.83-7.83Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.7,128c0,4.32,3.5,7.83,7.83,7.83h5.87l3.91-7.83-3.91-7.83h-5.87c-4.32,0-7.83,3.5-7.83,7.83Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.26,120.17h-5.87v15.65h5.87c4.32,0,7.83-3.5,7.83-7.83s-3.5-7.83-7.83-7.83Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.7,151.48c0,4.32,3.5,7.83,7.83,7.83h5.87l3.91-7.83-3.91-7.83h-5.87c-4.32,0-7.83,3.5-7.83,7.83Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.26,143.65h-5.87v15.65h5.87c4.32,0,7.83-3.5,7.83-7.83s-3.5-7.83-7.83-7.83Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.7,174.96c0,4.32,3.5,7.83,7.83,7.83h5.87l3.91-7.83-3.91-7.83h-5.87c-4.32,0-7.83,3.5-7.83,7.83Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.26,167.13h-5.87v15.65h5.87c4.32,0,7.83-3.5,7.83-7.83s-3.5-7.83-7.83-7.83Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.7,81.04c0,4.32,3.5,7.83,7.83,7.83h5.87l3.91-7.83-3.91-7.83h-5.87c-4.32,0-7.83,3.5-7.83,7.83Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.26,73.22h-5.87v15.65h5.87c4.32,0,7.83-3.5,7.83-7.83s-3.5-7.83-7.83-7.83Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 133.48,
    y: 88.87,
    width: 36,
    height: 10.57
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M189.04,112.35v5.87l-7.83,25.43,7.83,25.43v5.87c0,10.76-8.8,19.57-19.57,19.57h-18l-11.74-52.83,11.74-48.91h18c10.76,0,19.57,8.8,19.57,19.57Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.48,92.78v101.74h-18c-10.76,0-19.57-8.8-19.57-19.57v-62.61c0-10.76,8.8-19.57,19.57-19.57h18Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "173.39 59.03 173.39 88.87 162.43 88.87 158.52 71.99 162.43 59.03 173.39 59.03"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "162.43 59.03 162.43 88.87 151.48 88.87 147.57 71.99 151.48 59.03 162.43 59.03"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "151.48 59.03 151.48 88.87 140.52 88.87 136.61 71.99 140.52 59.03 151.48 59.03"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 129.57,
    y: 59.03,
    width: 10.96,
    height: 29.84
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M181.22,124.09v50.87c0,6.47-5.27,11.74-11.74,11.74h-18l-3.91-66.52,33.65,3.91Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M181.22,112.35v11.74h-29.74l-7.83-11.74,7.83-11.74h18c6.47,0,11.74,5.27,11.74,11.74Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M155.39,124.09l-3.91,45v17.61h-18c-6.47,0-11.74-5.27-11.74-11.74v-50.87h33.65Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.48,100.61v17.61l3.91,5.87h-33.65v-11.74c0-6.47,5.27-11.74,11.74-11.74h18Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 151.48,
    y: 118.22,
    width: 37.57,
    height: 50.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicine);
export default __webpack_public_path__ + "static/media/medicine.20548264864173c1f110565a652acb4d.svg";
export { ForwardRef as ReactComponent };